import { render, staticRenderFns } from "./TemplateEditPopup.vue?vue&type=template&id=461f9030&scoped=true&"
import script from "./TemplateEditPopup.vue?vue&type=script&lang=js&"
export * from "./TemplateEditPopup.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEditPopup.vue?vue&type=style&index=0&id=461f9030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461f9030",
  null
  
)

export default component.exports